/**
 * Base Interface representing a PlatformFilter
 */
export interface IPlatformFilter {
  name: string;
}


export let emptyPlatformFilter: IPlatformFilter = {
  name: ''
};


// WEBPACK FOOTER //
// ./src/app/model/platform-filter.ts